import { motion } from 'framer-motion';
import { SEO } from '../components/SEO';

export const ImpresszumPage = () => {
  return (
    <main className="min-h-screen pt-32 pb-20" data-testid="impresszum-page">
      <SEO title="Impresszum" description="Akadémia Plusz 2.0 Kft. impresszuma. Céginformációk és kapcsolat." path="/impresszum" />
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto"
        >
          <h1 className="font-heading text-4xl md:text-5xl font-semibold text-white mb-8">
            Impresszum
          </h1>

          <div className="glass-card p-8 md:p-12 space-y-8 text-white/70 leading-relaxed">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <p className="text-white/80 font-medium mb-1">Szolgáltató neve</p>
                <p className="text-white font-semibold">Akadémia Plusz 2.0 Korlátolt Felelősségű Társaság</p>
              </div>
              <div>
                <p className="text-white/80 font-medium mb-1">Székhely</p>
                <p className="text-white font-semibold">1027 Budapest, Kapás utca 6–12</p>
              </div>
              <div>
                <p className="text-white/80 font-medium mb-1">Cégjegyzékszám</p>
                <p className="text-white font-semibold">01-09-322887</p>
              </div>
              <div>
                <p className="text-white/80 font-medium mb-1">Adószám</p>
                <p className="text-white font-semibold">26300575-2-41</p>
              </div>
            </div>

            <div>
              <p className="text-white/80 font-medium mb-2">Elérhetőség</p>
              <p>
                E-mail: <a href="mailto:akademia@dh.hu" className="text-[#56999B] hover:text-[#C4DB72] transition-colors font-semibold">akademia@dh.hu</a>
              </p>
              <p>
                Telefon: <a href="tel:+36705188091" className="text-[#56999B] hover:text-[#C4DB72] transition-colors font-semibold">+36 70 518 8091</a>
              </p>
            </div>

            <div>
              <p className="text-white/80 font-medium mb-1">Tevékenység</p>
              <p>Felnőttképzési és készségfejlesztő képzések szervezése.</p>
            </div>

          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default ImpresszumPage;
